<template>
  <view class="main">
    <ChildTab
      wx:if="{{tabsData.length > 0}}"
      tabs="{{tabsData}}"
      actived="{{tabChoosed}}"
      bindtabTap="onTabTap"
    />
    <CitySelect
      type="{{supportMutipleCity ? 'mutiple' : 'single'}}"
      fromCitys="{{showCitys.fromCitys}}"
      toCitys="{{showCitys.toCitys}}"
      exchangeIcon="https://ut-static.udache.com/webx/sfc/JsPgN2DbbpIWdjLaBQLfd.png"
      bind:exchange="onExchange"
      bind:cityTap="onCityTap"
    />
    <DateSelect
      type="{{dateSelectType}}"
      fromDate="{{selectDate.fromDate}}"
      toDate="{{selectDate.toDate}}"
      bind:dateTap="onDateTap"
      fuzzy="{{fuzzy}}"
      fuzzyDate="{{selectDate.fuzzyDate}}"
    />
    <Cabin wx:if="{{cabinVisible}}" />
    <view bindtap="queryConfirm" class="query-button-area">
      <view class="query-button">查询机票</view>
      <BubbleBtn class="bubble-btn" bubbleText="{{bubbleText}}" />
    </view>
  </view>
  <CalendarPopup
    bizType="flights"
    wx:model="{{calendarPopupVisible}}"
    minDate="{{calendarConfig.minDate}}"
    maxDate="{{calendarConfig.maxDate}}"
    subTexts="{{calendarConfig.prices}}"
    type="{{calendarConfig.type}}"
    selectDate="{{calendarConfig.selectDate}}"
    fuzzy="{{fuzzy}}"
    fuzzyDate="{{selectDate.fuzzyDate}}"
    bindconfirm="onCalendarConfirm"
  />
  <CityPopup
    wx:model="{{cityPopupVisible}}"
    title="{{cityPopupTitle}}"
    bizType="flights"
    bindconfirm="cityConfirm"
  />
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import store from '@/store'
  import { innerRouter, pagePath } from '@/common/jump'
  import dayjs from 'dayjs'
  import { utils } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  import { FLIGHTS_TYPES } from '@/common/enum'
  import { getCalendarPrice } from '@/api/flights'

  createComponent({
    data: {
      tabChoosed: FLIGHTS_TYPES.ONE,
      calendarPopupVisible: false,
      cityPopupVisible: false,
      cityPopupTitle: '选择出发地',
      calendarPrices: [],
    },
    computed: {
      ...store.mapGetters({
        selectCitys: 'flights.selectCitys',
        selectDate: 'flights.selectDate',
      }),
      ...store.mapState({
        flightsCouponData: 'flights.flightsCouponData',
        flightsQuery: 'flights.flightsQuery',
        queryCardBtnText: 'flights.queryCardBtnText',
      }),
      calendarConfig() {
        const MAX_DAYS = 365 - 1
        const TODAY = dayjs()
        const minDate = TODAY.format('YYYY-MM-DD')
        const maxDate = TODAY.add(MAX_DAYS, 'd').format('YYYY-MM-DD')
        const type = this.tabChoosed === FLIGHTS_TYPES.RT ? 'range' : 'single'
        const selectDate = this.tabChoosed === FLIGHTS_TYPES.RT
          ? [this.selectDate.fromDate, this.selectDate.toDate]
          : [this.selectDate.fromDate]
        return {
          minDate,
          maxDate,
          type,
          selectDate,
          prices: this.tabChoosed === FLIGHTS_TYPES.RT ? [] : this.calendarPrices
        }
      },
      tabsData() {
        return [{
          key: FLIGHTS_TYPES.ONE,
          text: '单程',
        },{
          key: FLIGHTS_TYPES.RT,
          text: '往返',
        }]
      },
      cabinVisible() {
        return [
          FLIGHTS_TYPES.ONE,
          FLIGHTS_TYPES.RT,
        ].includes(this.tabChoosed)
      },
      dateSelectType() {
        return this.tabChoosed === FLIGHTS_TYPES.RT
          ? 'range'
          : 'single'
      },
      fuzzy() {
        return this.tabChoosed === FLIGHTS_TYPES.SP
      },
      // 多选城市 or 单选城市
      supportMutipleCity() {
        return this.tabChoosed === FLIGHTS_TYPES.SP
      },
      showCitys() {
        const {
          fromCitys,
          toCitys,
          spFromCitys,
          spToCitys,
        } = this.selectCitys
        return this.supportMutipleCity
          ? {
              fromCitys: spFromCitys,
              toCitys: spToCitys,
            }
          : { fromCitys, toCitys }
      },
      bubbleText() {
        return this.queryCardBtnText
      },
    },
    methods: {
      ...store.mapActions({
        checkPrivacyStatus:'flights.checkPrivacyStatus',
        jumpTcUrl:'flights.jumpTcUrl',
      }),
      ...store.mapMutations({
        setFlightsQuery: 'flights.setFlightsQuery',
      }),
      onTabTap({ detail }) {
        trackEvent('userteam_plane_home_search_ck', 'UT-飞机票-首页-搜索按钮-点击', {
          type: detail.key
        })
        this.tabChoosed = detail.key
      },
      onExchange() {
        const {
          fromCitys,
          toCitys,
          spFromCitys,
          spToCitys,
        } = this.selectCitys
        const needChangedQuery = this.supportMutipleCity
          ? {
              spFromCitys: spToCitys,
              spToCitys: spFromCitys,
            }
          : {
              fromCitys: toCitys,
              toCitys: fromCitys,
            }
        this.setFlightsQuery(needChangedQuery)
      },
      async onCityTap({ detail }) {
        await this.checkPrivacyStatus()
        this.cityPopupTitle = detail === 'from' ? '选择出发地' : '选择目的地'
        this.cityPopupVisible = true
      },
      cityConfirm({ detail }) {
        const { city_id, city_name, name, id, type } = detail
        const _city = [{
          city_id,
          city_name,
          name: name || city_name,
          id: id || city_id,
          type: type || 0, // 0国内城市 2国内机场
        }]
        const _query = this.cityPopupTitle === '选择目的地'
          ? { toCitys: _city }
          : { fromCitys: _city }
        this.setFlightsQuery(_query)
      },
      onDateTap() {
        this.calendarPopupVisible = true
        const _cabin = this.flightsQuery.cabin || 0
        if(this.calendarConfig.type === 'single' && _cabin === 0) {
          getCalendarPrice({
            depCityCode: this.showCitys.fromCitys[0].city_id,
            arrCityCode: this.showCitys.toCitys[0].city_id,
            cabinLevel: _cabin,
          }).then(res => {
            if(res.code === 200) {
              const { priceInfos } = res.data
              this.calendarPrices = (priceInfos || []).map(({ date, price, flag }) => ({
                date: dayjs(date).format('YYYY-MM-DD'),
                text: price ? '¥' + price : '-',
                highlight: flag,
              }))
            }
          })
        }else{
          this.calendarPrices = []
        }
      },
      onCalendarConfirm({ detail }) {
        if(this.tabChoosed === FLIGHTS_TYPES.ONE) {
          this.setFlightsQuery({
            fromDate: dayjs(detail.single).format('YYYY-MM-DD')
          })
        }else if(this.tabChoosed === FLIGHTS_TYPES.RT) {
          const [start, end] = detail.range
          this.setFlightsQuery({
            fromDate: dayjs(start).format('YYYY-MM-DD'),
            toDate: dayjs(end).format('YYYY-MM-DD'),
          })
        }else if(this.tabChoosed === FLIGHTS_TYPES.SP) {
          if(detail.single) {
            this.setFlightsQuery({
              fromDate: dayjs(detail.single).format('YYYY-MM-DD'),
              fuzzyDate: null
            })
          }else if(detail.fuzzy){
            this.setFlightsQuery({
              fuzzyDate: utils.cloneDeep(detail.fuzzy)
            })
          }
        }
      },
      async queryConfirm() {
        trackEvent('yks_plane_home_tickets_ck', '迎客松-机票-首页-订票主卡-点击', {
          button: 'search',
          type: this.tabChoosed === FLIGHTS_TYPES.ONE
            ? 'uniaxial'
            : 'biaxial'
        })
        await this.checkPrivacyStatus()
        this.jumpTcUrl({
          type: `query-${this.tabChoosed}`,
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
.main
  background #fff
  border-radius 16px
  overflow hidden
  padding 0 16px 16px
  margin-bottom 8px
  .query-button-area
    position relative
    .query-button
      height 50px
      line-height 50px
      font-size 16px
      text-align center
      color white
      border-radius 12px
      background-color #FF6400
      font-weight 600
    .bubble-btn
      position absolute
      top -10px
      right 0
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'ChildTab': './child-tab',
      'CitySelect': './city-select',
      'DateSelect': './date-select',
      'Cabin': './cabin',
      'CalendarPopup': '@/components/calendar-popup',
      'CityPopup': '@/components/city-popup',
      'BubbleBtn': '../bubble-btn',
    }
  }
</script>
